import { connect } from 'react-redux'
import MediaMenu from './MediaMenu'
import { State } from '../../dataStore/reducers/reducerType'
import { MediaMenuProps } from './types'

const mapStateToProps = (state: State): MediaMenuProps => ({
  playInEnabled: state.config.featureFlags.playIn,
  screenshareEnabled: state.config.featureFlags.screenshare,
  slidesEnabled: state.config.featureFlags.slides,
  spotlightEnabled: state.config.featureFlags.spotlight,
  streamEnabled: state.config.serviced && state.config.featureFlags.eventStream
})

export default connect(mapStateToProps)(MediaMenu)
